export const formatPrice = (price?: string | number, currencyCode?: string): string => {
  if (!price || isNaN(Number(price))) return '';

  const formatted = Number(price).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return currencyCode ? `${formatted} ${currencyCode}` : `${formatted}`;
};
